/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AudienceFilterFromJSON, AudienceFilterToJSON } from './AudienceFilter';
/**
 * Check if a given object implements the CampaignResponse interface.
 */
export function instanceOfCampaignResponse(value) {
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('documentVersion' in value) || value['documentVersion'] === undefined)
        return false;
    if (!('failedCount' in value) || value['failedCount'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('pendingCount' in value) || value['pendingCount'] === undefined)
        return false;
    if (!('sentCount' in value) || value['sentCount'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('template' in value) || value['template'] === undefined)
        return false;
    if (!('totalRecipients' in value) || value['totalRecipients'] === undefined)
        return false;
    return true;
}
export function CampaignResponseFromJSON(json) {
    return CampaignResponseFromJSONTyped(json, false);
}
export function CampaignResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'audienceFilter': json['audience_filter'] == null ? undefined : AudienceFilterFromJSON(json['audience_filter']),
        'completedAt': json['completed_at'] == null ? undefined : (new Date(json['completed_at'])),
        'createdAt': (new Date(json['created_at'])),
        'createdBy': json['created_by'] == null ? undefined : json['created_by'],
        'dispatchedAt': json['dispatched_at'] == null ? undefined : (new Date(json['dispatched_at'])),
        'documentVersion': json['document_version'],
        'failedCount': json['failed_count'],
        'id': json['id'],
        'params': json['params'] == null ? undefined : json['params'],
        'pendingCount': json['pending_count'],
        'sentCount': json['sent_count'],
        'status': json['status'],
        'tasksEnqueued': json['tasks_enqueued'] == null ? undefined : json['tasks_enqueued'],
        'template': json['template'],
        'testSentAt': json['test_sent_at'] == null ? undefined : (new Date(json['test_sent_at'])),
        'totalRecipients': json['total_recipients'],
    };
}
export function CampaignResponseToJSON(json) {
    return CampaignResponseToJSONTyped(json, false);
}
export function CampaignResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'audience_filter': AudienceFilterToJSON(value['audienceFilter']),
        'completed_at': value['completedAt'] == null ? value['completedAt'] : value['completedAt'].toISOString(),
        'created_at': value['createdAt'].toISOString(),
        'created_by': value['createdBy'],
        'dispatched_at': value['dispatchedAt'] == null ? value['dispatchedAt'] : value['dispatchedAt'].toISOString(),
        'document_version': value['documentVersion'],
        'failed_count': value['failedCount'],
        'id': value['id'],
        'params': value['params'],
        'pending_count': value['pendingCount'],
        'sent_count': value['sentCount'],
        'status': value['status'],
        'tasks_enqueued': value['tasksEnqueued'],
        'template': value['template'],
        'test_sent_at': value['testSentAt'] == null ? value['testSentAt'] : value['testSentAt'].toISOString(),
        'total_recipients': value['totalRecipients'],
    };
}
